import { io } from 'socket.io-client';

const API = import.meta.env.VITE_API_URL || 'https://funnytask.net/api';
const SOCKET_URL = API.replace(/\/api\/?$/, '');

let socket = null;
let presenceWired = false;

// Tab có đang được XEM không = hiển thị (không ẩn/minimize) và đang focus.
function isViewing() {
  return document.visibilityState === 'visible' && document.hasFocus();
}
function emitPresence() {
  if (socket && socket.connected) socket.emit('presence:active', isViewing());
}
// Gắn listener 1 lần: đổi focus/hiển thị -> báo server để bật/tắt web push cho tab này.
function wirePresence() {
  if (presenceWired) return;
  presenceWired = true;
  window.addEventListener('focus', emitPresence, { passive: true });
  window.addEventListener('blur', emitPresence, { passive: true });
  document.addEventListener('visibilitychange', emitPresence, { passive: true });
}

export function connectSocket() {
  const token = localStorage.getItem('ft_token');
  if (!token) return null;
  if (socket && socket.connected) return socket;
  if (socket) { socket.connect(); return socket; }
  socket = io(SOCKET_URL, { auth: { token }, transports: ['websocket', 'polling'] });
  socket.on('connect', emitPresence); // báo trạng thái ngay khi (tái) kết nối
  wirePresence();
  return socket;
}

export function getSocket() {
  return socket;
}

// Báo "đang gõ" tới các thành viên khác của hội thoại (client tự gửi kèm danh sách người nhận).
export function emitTyping(convId, to, typing) {
  if (socket && socket.connected) socket.emit('chat:typing', { convId, to, typing });
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
